import WithAdditionalValidationState from 'components/WithAdditionalValidation/WithAdditionalValidationState';
import {
	CreateTeaserContext,
	ICreateTeaserContext,
} from 'modules/Teasers/CreateTeaser/createTeaserState/createTeaserContext';
import FormDataImgUploader from './FormDataImgUploader/FormDataImgUploader';
import FormDataTeaserUploader from './FormDataTeaserUploader/FormDataTeaserUploader';
import React, { useContext } from 'react';
import classNames from 'classnames';
import InputFields from './InputFields/InputFields';
import style from './CreationForm.module.scss';

interface ICreationForm {
	isVisible: boolean;
}

const CreationForm: React.FC<ICreationForm> = ({ isVisible }) => {
	const { selectedContentType } = useContext<ICreateTeaserContext>(CreateTeaserContext);

	const containerClasses = classNames(style.container, { [style.visible]: isVisible });

	const renderUploader = () => {
		const photoContentType =
			selectedContentType === 'AdvertisingImage' ||
			selectedContentType === 'AssistantImage' ||
			selectedContentType === 'GameLaunchImage';
		const videoContentType =
			selectedContentType === 'AdvertisingVideo' ||
			selectedContentType === 'AssistantVideo' ||
			selectedContentType === 'GameLaunchVideo';

		if (photoContentType) {
			return <FormDataImgUploader />;
		}
		if (videoContentType) {
			return <FormDataTeaserUploader />;
		}
		return <FormDataTeaserUploader />;
	};

	return (
		<div className={containerClasses} data-test="CreationForm">
			<WithAdditionalValidationState>
				{renderUploader()}
				<InputFields />
			</WithAdditionalValidationState>
		</div>
	);
};

export default CreationForm;
